import React from 'react'
import { Navigate, RouteObject } from 'react-router-dom'
import { RouteRoleGuard } from '../layouts/RouteRoleGuard/RouteRoleGuard'
import { LayoutAdmin } from '../layouts/Admin/Admin'

import SettingsPage from '../pages/pro/Settings/Settings'
import { Introduction, AdditionalInfo } from '../pages/pro/recording'
import BrandSettingsResetPassword from '../pages/brand/settings/ResetPassword'
import SignInMethods from '../components/auth/SignInMethods'

import { MyProVideos } from '../pages/pro/myVideos'
import { MyProBrands } from '../pages/pro/myBrands'
import EditMe from '../pages/pro/createEditProfile/EditMe'
// Experts use the same dynamic, role-scoped notification-settings page as brand
// and internal users (it filters by role). The old static ProNotificationSettings
// page had 3 hardcoded toggles saved to settings.notification, which nothing on
// the backend reads (dead). See notificationKinds for what PRO can control.
import BrandNotificationSetting from '../pages/brand/settings/notification/Notification'
import ExpertProjects from '../pages/pro/projects/ExpertProjects'
import ConfirmationDetails from '../pages/pro/projects/ConfirmationDetails'
import ExpertResourcesPage from '../pages/expertResources'

export const ProRoutes: RouteObject[] = [
  {
    path: '/',
    element: (
      <RouteRoleGuard role="PRO">
        <LayoutAdmin />
      </RouteRoleGuard>
    ),
    children: [
      {
        path: '',
        element: <Navigate to="/profile" />,
      },
      {
        path: 'pro/recording/intro',
        element: <Introduction />,
      },
      {
        path: 'my-videos',
        element: <MyProVideos />,
      },
      {
        path: 'my-brands',
        element: <MyProBrands />,
      },
      {
        path: 'pro/recording/additional-info',
        element: <AdditionalInfo />,
      },
      {
        path: 'profile',
        element: <EditMe />,
      },
      {
        path: 'expert/projects',
        element: <ExpertProjects />,
      },
      {
        path: 'expert/project/:projectId/confirmation-details',
        element: <ConfirmationDetails />,
      },
      {
        path: 'expert-resources',
        element: <ExpertResourcesPage />,
      },
      {
        path: 'settings/*',
        element: <SettingsPage />,
        children: [
          {
            path: '',
            element: <Navigate to="/settings/reset-password" />,
          },
          {
            path: 'profile',
            element: <Navigate to="/profile" />,
          },
          {
            path: 'reset-password',
            element: <BrandSettingsResetPassword />,
          },
          {
            path: 'sign-in-methods',
            element: <SignInMethods />,
          },
          {
            path: 'notifications',
            element: <BrandNotificationSetting />,
          },
          { 
            path: '*', 
            element: <Navigate to="/404" /> 
          },
        ],
      },
      {
        path: '*',
        element: <Navigate to="/404" />,
      },
    ],
  },
]
